// dynamicUiSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isEditingUi: false, // NEW: global edit-mode for Dynamic UI
};

const dynamicUiSlice = createSlice({
  name: 'dynamicUi',
  initialState,
  reducers: {
    setIsEditingUi(state, action) {
      state.isEditingUi = !!action.payload; // boolean coerce
    },
    toggleIsEditingUi(state) { // optional convenience
      state.isEditingUi = !state.isEditingUi;
    },
  },
});

export const { setIsEditingUi, toggleIsEditingUi } = dynamicUiSlice.actions;
export default dynamicUiSlice.reducer;